import axios from 'axios'
import { castAttributesForCamelCase } from '../../modules/string_converter'

export const companiesSearchPatterns = {
  namespaced: true,
  state: {
    data: [],
    searchPatternId: null,
    loading: false
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
    },
    apiFailure(state) {
      state.data = null
      state.loading = false
    },
    apiSuccess(state) {
      state.loading = false
    },
    readSearchPatternsSuccess(state, payload) {
      state.data = payload.data.map(v => castAttributesForCamelCase(v.attributes))
      state.loading = false
    },
    readSearchPatternSuccess(state, payload) {
      state.data = castAttributesForCamelCase(payload.data.attributes)
      state.loading = false
    },
    createSearchPatternSuccess(state, payload) {
      state.searchPatternId = payload.data.id
      state.loading = false
    },
    resetSearchPatternId(state) {
      state.searchPatternId = null
    }
  },
  actions: {
    resetSearchPatternId({ commit }) {
      commit('resetSearchPatternId')
    },
    readSearchPatterns({ commit, rootState }) {
      commit('apiConnect')
      return axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/search_patterns.json`)
        .then(res => {
          commit('readSearchPatternsSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readSearchPattern({ commit, rootState }, search_pattern_id) {
      commit('apiConnect')
      return axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/search_patterns/${search_pattern_id}.json`)
        .then(res => {
          commit('readSearchPatternSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    createSearchPattern({ commit, rootState }, payload) {
      commit('apiConnect')
      return axios
        .post(`/api/companies/${rootState.route.params.company_uuid}/search_patterns.json`, payload)
        .then(res => {
          commit('createSearchPatternSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    updateSearchPattern({ commit, rootState }, { searchPatternId: searchPatternId,  payload: payload }) {
      commit('apiConnect')
      return axios
        .patch(`/api/companies/${rootState.route.params.company_uuid}/search_patterns/${searchPatternId}`, payload)
        .then(res => {
          commit('createSearchPatternSuccess', res.data)
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          return false
        })
    },
    deleteSearchPattern({ commit, rootState }, id) {
      commit('apiConnect')
      return axios
        .delete(`/api/companies/${rootState.route.params.company_uuid}/search_patterns/${id}.json`)
        .then(() => {
          commit('apiSuccess')
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    }
  }
}